import React from "react";

import GroheCartHeaderCommon from "../groheCartHeaderCommon";
import GroheCartColumns from "../groheCartColumns";
import GroheCartCardColumns from "../groheCartCardColumns";

const GroheCartConfirmHeader = () => {

  return (
    <div className="gc-confirm__header">
      <GroheCartHeaderCommon title="grohe.cart.confirm.title" subTitle="grohe.cart.confirm.subTitle"/>
      <div className="gc-confirm__columns">
        <div className="gc-confirm__columns-left">
          <GroheCartColumns/>
        </div>
        <div className="gc-confirm__columns-right">
          <GroheCartCardColumns/>
        </div>
      </div>
    </div>
  )
};

export default GroheCartConfirmHeader
